// @flow
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';
// $FlowFixMe - TS file
import env from 'bench-environment';

const restLink = new RestLink({
  uri: `${env.location.apiRoot}/api/v1/`, // default if endpoint not specified in query
  endpoints: {
    mainapp: `${env.location.apiRoot}/api/v1/`,
    gateway: `${env.location.apiRoot}/gateway/web/api/`,
    reports: `${env.location.apiRoot}/reports/api/`,
  },
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  typePatcher: {
    Client: (data: any): any => ({
      ...data,
      more: {
        __typename: 'ClientMore',
        ...data.more,
      },
    }),
    CreateClientGustoAccount: (data: Object): any => ({
      __typename: 'CreateClientGustoAccount',
      ...data,
    }),
    TopSpendingReport: (data: Object): any => ({
      __typename: 'TopSpendingReport',
      ledgerAccountSummaries: data.ledgerAccountSummaries
        ? data.ledgerAccountSummaries.map(ledgerAccountSummary => ({
            __typename: 'LedgerAccountSummary',
            ...ledgerAccountSummary,
          }))
        : [],
    }),
    CashFlowSummaryReport: (data: Object): any => ({
      __typename: 'CashFlowSummaryReport',
      accounts: data.accounts
        ? data.accounts.map(account => ({
            __typename: 'CashFlowSummaryAccount',
            ...account,
          }))
        : [],
      cashFlowTotals: data.cashFlowTotals
        ? data.cashFlowTotals.map(cashFlowTotal => ({
            __typename: 'CashFlowSummaryTotal',
            ...cashFlowTotal,
          }))
        : [],
    }),
  },
});

const httpLink = new HttpLink({
  uri: `${env.location.apiRoot}/graphql/query`,
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes: {
      TransactionOrJournalEntry: ['Transaction', 'JournalEntry'],
    },
  }),
  link: ApolloLink.from([restLink, httpLink]),
});

export default apolloClient;
